import type {Relation} from "typeorm";
import {ChildEntity, JoinColumn, ManyToOne, OneToOne, RelationId} from "typeorm";
import {Negotiation} from "@/modules/diplomacy/entity";
import {TransferOffer} from "@/modules/transfer-market/entity/TransferOffer";
import {Player} from "@/modules/team/entity";

@ChildEntity()
export class TransferPlayerNegotiation extends Negotiation {
  @ManyToOne(() => Player, r => r.negotiations)
  declare target: Relation<Player>;

  @OneToOne(() => TransferOffer, r => r.playerNegotiation, {createForeignKeyConstraints: false})
  @JoinColumn()
  offer: Relation<TransferOffer>;

  @RelationId((e: TransferPlayerNegotiation) => e.offer)
  offerId: number;
}
